export default __webpack_public_path__ + "static/media/Q19_2_resized.82d136af.jpg";